import { AgencyBrandingKeys, type AgencyBranding } from '@ag-common-lib/lib/models/utils/agency-branding.model';
import type { IAspectRatio } from '@ag-common-lib/public-api';

export interface AgencyBrandingPreviewRow {
  name: string;
  premium: number;
  count: number;
}

export interface AgencyBrandingColorField {
  key: Exclude<AgencyBrandingKeys, AgencyBrandingKeys.logo>;
  label: string;
  hint: string;
}

export const AGENCY_BRANDING_PREVIEW_TITLE = 'Weekly Leaders Bulletin';
export const AGENCY_BRANDING_PREVIEW_SUBTITLE = 'Personal Submitted';
export const AGENCY_BRANDING_PREVIEW_PERIOD = 'Reporting period: Aug 1, 2026 - Aug 7, 2026';

/**
 * Report logo crop aspect ratio — TBD (must match production PDF branding logo slot).
 * Temporary wide ratio used until report dimensions are confirmed.
 */
export const AGENCY_BRANDING_LOGO_ASPECT_RATIO: IAspectRatio = { w: 5, h: 2 };

export const AGENCY_BRANDING_PREVIEW_ROWS: readonly AgencyBrandingPreviewRow[] = [
  { name: 'JANE DOE', premium: 40274.88, count: 25 },
  { name: 'JOHN SMITH', premium: 4029.5, count: 3 },
];

export const AGENCY_BRANDING_COLOR_FIELDS: readonly AgencyBrandingColorField[] = [
  {
    key: AgencyBrandingKeys.bannerColor,
    label: 'Banner Color',
    hint: 'Main color that will be applied for banner, stroke lines, table header.',
  },
  {
    key: AgencyBrandingKeys.bulletinTitleColor,
    label: 'Bulletin Color',
    hint: 'Color of Bulletin Title displayed on banner and Columns Header.',
  },
  {
    key: AgencyBrandingKeys.reportTitleColor,
    label: 'Report Color',
    hint: 'Color of Report Title displayed after banner.',
  },
  {
    key: AgencyBrandingKeys.tableTextColor,
    label: 'Table Text Color',
    hint: 'Color of table text.',
  },
];

export const getAgencyBrandingPreviewTotals = (
  rows: readonly AgencyBrandingPreviewRow[],
): AgencyBrandingPreviewRow =>
  rows.reduce(
    (totals, row) => ({
      name: 'Total',
      premium: totals.premium + row.premium,
      count: totals.count + row.count,
    }),
    { name: 'Total', premium: 0, count: 0 },
  );

export const areAgencyBrandingsEqual = (left: AgencyBranding, right: AgencyBranding): boolean =>
  JSON.stringify(left) === JSON.stringify(right);
